export const MORFIX_CREATE_ENC_PARMS_REQUEST = 'MORFIX_CREATE_ENC_PARMS_REQUEST'
export const MORFIX_CREATE_ENC_PARMS_SUCCESS = 'MORFIX_CREATE_ENC_PARMS_SUCCESS'
export const MORFIX_CREATE_ENC_PARMS_FAILURE = 'MORFIX_CREATE_ENC_PARMS_FAILURE'

export const MORFIX_CREATE_CONTEXT_REQUEST = 'MORFIX_CREATE_CONTEXT_REQUEST'
export const MORFIX_CREATE_CONTEXT_SUCCESS = 'MORFIX_CREATE_CONTEXT_SUCCESS'
export const MORFIX_CREATE_CONTEXT_FAILURE = 'MORFIX_CREATE_CONTEXT_FAILURE'

export const MORFIX_CREATE_KEY_GENERATOR_REQUEST = 'MORFIX_CREATE_KEY_GENERATOR_REQUEST'
export const MORFIX_CREATE_KEY_GENERATOR_SUCCESS = 'MORFIX_CREATE_KEY_GENERATOR_SUCCESS'
export const MORFIX_CREATE_KEY_GENERATOR_FAILURE = 'MORFIX_CREATE_KEY_GENERATOR_FAILURE'

export const MORFIX_DELETE_PUBLIC_KEY_REQUEST = 'MORFIX_DELETE_PUBLIC_KEY_REQUEST'
export const MORFIX_DELETE_PUBLIC_KEY_SUCCESS = 'MORFIX_DELETE_PUBLIC_KEY_SUCCESS'
export const MORFIX_DELETE_PUBLIC_KEY_FAILURE = 'MORFIX_DELETE_PUBLIC_KEY_FAILURE'

export const MORFIX_DELETE_SECRET_KEY_REQUEST = 'MORFIX_DELETE_SECRET_KEY_REQUEST'
export const MORFIX_DELETE_SECRET_KEY_SUCCESS = 'MORFIX_DELETE_SECRET_KEY_SUCCESS'
export const MORFIX_DELETE_SECRET_KEY_FAILURE = 'MORFIX_DELETE_SECRET_KEY_FAILURE'

export const MORFIX_DELETE_RELIN_KEY_REQUEST = 'MORFIX_DELETE_RELIN_KEY_REQUEST'
export const MORFIX_DELETE_RELIN_KEY_SUCCESS = 'MORFIX_DELETE_RELIN_KEY_SUCCESS'
export const MORFIX_DELETE_RELIN_KEY_FAILURE = 'MORFIX_DELETE_RELIN_KEY_FAILURE'

export const MORFIX_DELETE_GALOIS_KEY_REQUEST = 'MORFIX_DELETE_GALOIS_KEY_REQUEST'
export const MORFIX_DELETE_GALOIS_KEY_SUCCESS = 'MORFIX_DELETE_GALOIS_KEY_SUCCESS'
export const MORFIX_DELETE_GALOIS_KEY_FAILURE = 'MORFIX_DELETE_GALOIS_KEY_FAILURE'

export const MORFIX_SET_ACTIVE_PUBLIC_KEY_REQUEST = 'MORFIX_SET_ACTIVE_PUBLIC_KEY_REQUEST'
export const MORFIX_SET_ACTIVE_PUBLIC_KEY_SUCCESS = 'MORFIX_SET_ACTIVE_PUBLIC_KEY_SUCCESS'
export const MORFIX_SET_ACTIVE_PUBLIC_KEY_FAILURE = 'MORFIX_SET_ACTIVE_PUBLIC_KEY_FAILURE'

export const MORFIX_SET_ACTIVE_SECRET_KEY_REQUEST = 'MORFIX_SET_ACTIVE_SECRET_KEY_REQUEST'
export const MORFIX_SET_ACTIVE_SECRET_KEY_SUCCESS = 'MORFIX_SET_ACTIVE_SECRET_KEY_SUCCESS'
export const MORFIX_SET_ACTIVE_SECRET_KEY_FAILURE = 'MORFIX_SET_ACTIVE_SECRET_KEY_FAILURE'

export const MORFIX_SET_ACTIVE_RELIN_KEY_REQUEST = 'MORFIX_SET_ACTIVE_RELIN_KEY_REQUEST'
export const MORFIX_SET_ACTIVE_RELIN_KEY_SUCCESS = 'MORFIX_SET_ACTIVE_RELIN_KEY_SUCCESS'
export const MORFIX_SET_ACTIVE_RELIN_KEY_FAILURE = 'MORFIX_SET_ACTIVE_RELIN_KEY_FAILURE'

export const MORFIX_SET_ACTIVE_GALOIS_KEY_REQUEST = 'MORFIX_SET_ACTIVE_GALOIS_KEY_REQUEST'
export const MORFIX_SET_ACTIVE_GALOIS_KEY_SUCCESS = 'MORFIX_SET_ACTIVE_GALOIS_KEY_SUCCESS'
export const MORFIX_SET_ACTIVE_GALOIS_KEY_FAILURE = 'MORFIX_SET_ACTIVE_GALOIS_KEY_FAILURE'

export const MORFIX_GENERATE_PUBLIC_KEY_REQUEST = 'MORFIX_GENERATE_PUBLIC_KEY_REQUEST'
export const MORFIX_GENERATE_PUBLIC_KEY_SUCCESS = 'MORFIX_GENERATE_PUBLIC_KEY_SUCCESS'
export const MORFIX_GENERATE_PUBLIC_KEY_FAILURE = 'MORFIX_GENERATE_PUBLIC_KEY_FAILURE'

export const MORFIX_GENERATE_SECRET_KEY_REQUEST = 'MORFIX_GENERATE_SECRET_KEY_REQUEST'
export const MORFIX_GENERATE_SECRET_KEY_SUCCESS = 'MORFIX_GENERATE_SECRET_KEY_SUCCESS'
export const MORFIX_GENERATE_SECRET_KEY_FAILURE = 'MORFIX_GENERATE_SECRET_KEY_FAILURE'

export const MORFIX_GENERATE_RELIN_KEY_REQUEST = 'MORFIX_GENERATE_RELIN_KEY_REQUEST'
export const MORFIX_GENERATE_RELIN_KEY_SUCCESS = 'MORFIX_GENERATE_RELIN_KEY_SUCCESS'
export const MORFIX_GENERATE_RELIN_KEY_FAILURE = 'MORFIX_GENERATE_RELIN_KEY_FAILURE'

export const MORFIX_GENERATE_GALOIS_KEY_REQUEST = 'MORFIX_GENERATE_GALOIS_KEY_REQUEST'
export const MORFIX_GENERATE_GALOIS_KEY_SUCCESS = 'MORFIX_GENERATE_GALOIS_KEY_SUCCESS'
export const MORFIX_GENERATE_GALOIS_KEY_FAILURE = 'MORFIX_GENERATE_GALOIS_KEY_FAILURE'

export const MORFIX_TRIGGER_DOWNLOAD_REQUEST = 'MORFIX_TRIGGER_DOWNLOAD_REQUEST'
export const MORFIX_TRIGGER_DOWNLOAD_SUCCESS = 'MORFIX_TRIGGER_DOWNLOAD_SUCCESS'
export const MORFIX_TRIGGER_DOWNLOAD_FAILURE = 'MORFIX_TRIGGER_DOWNLOAD_FAILURE'

export const MORFIX_DOWNLOAD_PUBLIC_KEY_REQUEST = 'MORFIX_DOWNLOAD_PUBLIC_KEY_REQUEST'
export const MORFIX_DOWNLOAD_PUBLIC_KEY_SUCCESS = 'MORFIX_DOWNLOAD_PUBLIC_KEY_SUCCESS'
export const MORFIX_DOWNLOAD_PUBLIC_KEY_FAILURE = 'MORFIX_DOWNLOAD_PUBLIC_KEY_FAILURE'

export const MORFIX_DOWNLOAD_SECRET_KEY_REQUEST = 'MORFIX_DOWNLOAD_SECRET_KEY_REQUEST'
export const MORFIX_DOWNLOAD_SECRET_KEY_SUCCESS = 'MORFIX_DOWNLOAD_SECRET_KEY_SUCCESS'
export const MORFIX_DOWNLOAD_SECRET_KEY_FAILURE = 'MORFIX_DOWNLOAD_SECRET_KEY_FAILURE'

export const MORFIX_DOWNLOAD_RELIN_KEY_REQUEST = 'MORFIX_DOWNLOAD_RELIN_KEY_REQUEST'
export const MORFIX_DOWNLOAD_RELIN_KEY_SUCCESS = 'MORFIX_DOWNLOAD_RELIN_KEY_SUCCESS'
export const MORFIX_DOWNLOAD_RELIN_KEY_FAILURE = 'MORFIX_DOWNLOAD_RELIN_KEY_FAILURE'

export const MORFIX_DOWNLOAD_GALOIS_KEY_REQUEST = 'MORFIX_DOWNLOAD_GALOIS_KEY_REQUEST'
export const MORFIX_DOWNLOAD_GALOIS_KEY_SUCCESS = 'MORFIX_DOWNLOAD_GALOIS_KEY_SUCCESS'
export const MORFIX_DOWNLOAD_GALOIS_KEY_FAILURE = 'MORFIX_DOWNLOAD_GALOIS_KEY_FAILURE'

export const MORFIX_UPLOAD_PUBLIC_KEY_REQUEST = 'MORFIX_UPLOAD_PUBLIC_KEY_REQUEST'
export const MORFIX_UPLOAD_PUBLIC_KEY_SUCCESS = 'MORFIX_UPLOAD_PUBLIC_KEY_SUCCESS'
export const MORFIX_UPLOAD_PUBLIC_KEY_FAILURE = 'MORFIX_UPLOAD_PUBLIC_KEY_FAILURE'

export const MORFIX_UPLOAD_SECRET_KEY_REQUEST = 'MORFIX_UPLOAD_SECRET_KEY_REQUEST'
export const MORFIX_UPLOAD_SECRET_KEY_SUCCESS = 'MORFIX_UPLOAD_SECRET_KEY_SUCCESS'
export const MORFIX_UPLOAD_SECRET_KEY_FAILURE = 'MORFIX_UPLOAD_SECRET_KEY_FAILURE'

export const MORFIX_UPLOAD_RELIN_KEY_REQUEST = 'MORFIX_UPLOAD_RELIN_KEY_REQUEST'
export const MORFIX_UPLOAD_RELIN_KEY_SUCCESS = 'MORFIX_UPLOAD_RELIN_KEY_SUCCESS'
export const MORFIX_UPLOAD_RELIN_KEY_FAILURE = 'MORFIX_UPLOAD_RELIN_KEY_FAILURE'

export const MORFIX_UPLOAD_GALOIS_KEY_REQUEST = 'MORFIX_UPLOAD_GALOIS_KEY_REQUEST'
export const MORFIX_UPLOAD_GALOIS_KEY_SUCCESS = 'MORFIX_UPLOAD_GALOIS_KEY_SUCCESS'
export const MORFIX_UPLOAD_GALOIS_KEY_FAILURE = 'MORFIX_UPLOAD_GALOIS_KEY_FAILURE'

export const MORFIX_CREATE_INTEGER_ENCODER_REQUEST = 'MORFIX_CREATE_INTEGER_ENCODER_REQUEST'
export const MORFIX_CREATE_INTEGER_ENCODER_SUCCESS = 'MORFIX_CREATE_INTEGER_ENCODER_SUCCESS'
export const MORFIX_CREATE_INTEGER_ENCODER_FAILURE = 'MORFIX_CREATE_INTEGER_ENCODER_FAILURE'

export const MORFIX_CREATE_BATCH_ENCODER_REQUEST = 'MORFIX_CREATE_BATCH_ENCODER_REQUEST'
export const MORFIX_CREATE_BATCH_ENCODER_SUCCESS = 'MORFIX_CREATE_BATCH_ENCODER_SUCCESS'
export const MORFIX_CREATE_BATCH_ENCODER_FAILURE = 'MORFIX_CREATE_BATCH_ENCODER_FAILURE'

export const MORFIX_CREATE_CKKS_ENCODER_REQUEST = 'MORFIX_CREATE_CKKS_ENCODER_REQUEST'
export const MORFIX_CREATE_CKKS_ENCODER_SUCCESS = 'MORFIX_CREATE_CKKS_ENCODER_SUCCESS'
export const MORFIX_CREATE_CKKS_ENCODER_FAILURE = 'MORFIX_CREATE_CKKS_ENCODER_FAILURE'

export const MORFIX_CREATE_ENCRYPTOR_REQUEST = 'MORFIX_CREATE_ENCRYPTOR_REQUEST'
export const MORFIX_CREATE_ENCRYPTOR_SUCCESS = 'MORFIX_CREATE_ENCRYPTOR_SUCCESS'
export const MORFIX_CREATE_ENCRYPTOR_FAILURE = 'MORFIX_CREATE_ENCRYPTOR_FAILURE'

export const MORFIX_CREATE_DECRYPTOR_REQUEST = 'MORFIX_CREATE_DECRYPTOR_REQUEST'
export const MORFIX_CREATE_DECRYPTOR_SUCCESS = 'MORFIX_CREATE_DECRYPTOR_SUCCESS'
export const MORFIX_CREATE_DECRYPTOR_FAILURE = 'MORFIX_CREATE_DECRYPTOR_FAILURE'

export const MORFIX_DELETE_ENCRYPTOR_REQUEST = 'MORFIX_DELETE_ENCRYPTOR_REQUEST'
export const MORFIX_DELETE_ENCRYPTOR_SUCCESS = 'MORFIX_DELETE_ENCRYPTOR_SUCCESS'
export const MORFIX_DELETE_ENCRYPTOR_FAILURE = 'MORFIX_DELETE_ENCRYPTOR_FAILURE'

export const MORFIX_DELETE_DECRYPTOR_REQUEST = 'MORFIX_DELETE_DECRYPTOR_REQUEST'
export const MORFIX_DELETE_DECRYPTOR_SUCCESS = 'MORFIX_DELETE_DECRYPTOR_SUCCESS'
export const MORFIX_DELETE_DECRYPTOR_FAILURE = 'MORFIX_DELETE_DECRYPTOR_FAILURE'

export const MORFIX_CREATE_EVALUATOR_REQUEST = 'MORFIX_CREATE_EVALUATOR_REQUEST'
export const MORFIX_CREATE_EVALUATOR_SUCCESS = 'MORFIX_CREATE_EVALUATOR_SUCCESS'
export const MORFIX_CREATE_EVALUATOR_FAILURE = 'MORFIX_CREATE_EVALUATOR_FAILURE'

export const MORFIX_BATCH_ENCODE_INT32_REQUEST = 'MORFIX_BATCH_ENCODE_INT32_REQUEST'
export const MORFIX_BATCH_ENCODE_INT32_SUCCESS = 'MORFIX_BATCH_ENCODE_INT32_SUCCESS'
export const MORFIX_BATCH_ENCODE_INT32_FAILURE = 'MORFIX_BATCH_ENCODE_INT32_FAILURE'

export const MORFIX_BATCH_ENCODE_UINT32_REQUEST = 'MORFIX_BATCH_ENCODE_UINT32_REQUEST'
export const MORFIX_BATCH_ENCODE_UINT32_SUCCESS = 'MORFIX_BATCH_ENCODE_UINT32_SUCCESS'
export const MORFIX_BATCH_ENCODE_UINT32_FAILURE = 'MORFIX_BATCH_ENCODE_UINT32_FAILURE'

export const MORFIX_CKKS_ENCODE_FLOAT64_REQUEST = 'MORFIX_CKKS_ENCODE_FLOAT64_REQUEST'
export const MORFIX_CKKS_ENCODE_FLOAT64_SUCCESS = 'MORFIX_CKKS_ENCODE_FLOAT64_SUCCESS'
export const MORFIX_CKKS_ENCODE_FLOAT64_FAILURE = 'MORFIX_CKKS_ENCODE_FLOAT64_FAILURE'

export const MORFIX_BATCH_DECODE_INT32_REQUEST = 'MORFIX_BATCH_DECODE_INT32_REQUEST'
export const MORFIX_BATCH_DECODE_INT32_SUCCESS = 'MORFIX_BATCH_DECODE_INT32_SUCCESS'
export const MORFIX_BATCH_DECODE_INT32_FAILURE = 'MORFIX_BATCH_DECODE_INT32_FAILURE'

export const MORFIX_BATCH_DECODE_UINT32_REQUEST = 'MORFIX_BATCH_DECODE_UINT32_REQUEST'
export const MORFIX_BATCH_DECODE_UINT32_SUCCESS = 'MORFIX_BATCH_DECODE_UINT32_SUCCESS'
export const MORFIX_BATCH_DECODE_UINT32_FAILURE = 'MORFIX_BATCH_DECODE_UINT32_FAILURE'

export const MORFIX_CKKS_DECODE_FLOAT64_REQUEST = 'MORFIX_CKKS_DECODE_FLOAT64_REQUEST'
export const MORFIX_CKKS_DECODE_FLOAT64_SUCCESS = 'MORFIX_CKKS_DECODE_FLOAT64_SUCCESS'
export const MORFIX_CKKS_DECODE_FLOAT64_FAILURE = 'MORFIX_CKKS_DECODE_FLOAT64_FAILURE'

export const MORFIX_ENCRYPT_REQUEST = 'MORFIX_ENCRYPT_REQUEST'
export const MORFIX_ENCRYPT_SUCCESS = 'MORFIX_ENCRYPT_SUCCESS'
export const MORFIX_ENCRYPT_FAILURE = 'MORFIX_ENCRYPT_FAILURE'

export const MORFIX_DECRYPT_REQUEST = 'MORFIX_DECRYPT_REQUEST'
export const MORFIX_DECRYPT_SUCCESS = 'MORFIX_DECRYPT_SUCCESS'
export const MORFIX_DECRYPT_FAILURE = 'MORFIX_DECRYPT_FAILURE'

export const MORFIX_CREATE_PLAIN_TEXT_REQUEST = 'MORFIX_CREATE_PLAIN_TEXT_REQUEST'
export const MORFIX_CREATE_PLAIN_TEXT_SUCCESS = 'MORFIX_CREATE_PLAIN_TEXT_SUCCESS'
export const MORFIX_CREATE_PLAIN_TEXT_FAILURE = 'MORFIX_CREATE_PLAIN_TEXT_FAILURE'

export const MORFIX_READ_PLAIN_TEXT_REQUEST = 'MORFIX_READ_PLAIN_TEXT_REQUEST'
export const MORFIX_READ_PLAIN_TEXT_SUCCESS = 'MORFIX_READ_PLAIN_TEXT_SUCCESS'
export const MORFIX_READ_PLAIN_TEXT_FAILURE = 'MORFIX_READ_PLAIN_TEXT_FAILURE'

export const MORFIX_UPDATE_PLAIN_TEXT_REQUEST = 'MORFIX_UPDATE_PLAIN_TEXT_REQUEST'
export const MORFIX_UPDATE_PLAIN_TEXT_SUCCESS = 'MORFIX_UPDATE_PLAIN_TEXT_SUCCESS'
export const MORFIX_UPDATE_PLAIN_TEXT_FAILURE = 'MORFIX_UPDATE_PLAIN_TEXT_FAILURE'

export const MORFIX_DELETE_PLAIN_TEXT_REQUEST = 'MORFIX_DELETE_PLAIN_TEXT_REQUEST'
export const MORFIX_DELETE_PLAIN_TEXT_SUCCESS = 'MORFIX_DELETE_PLAIN_TEXT_SUCCESS'
export const MORFIX_DELETE_PLAIN_TEXT_FAILURE = 'MORFIX_DELETE_PLAIN_TEXT_FAILURE'

export const MORFIX_DOWNLOAD_PLAIN_TEXT_REQUEST = 'MORFIX_DOWNLOAD_PLAIN_TEXT_REQUEST'
export const MORFIX_DOWNLOAD_PLAIN_TEXT_SUCCESS = 'MORFIX_DOWNLOAD_PLAIN_TEXT_SUCCESS'
export const MORFIX_DOWNLOAD_PLAIN_TEXT_FAILURE = 'MORFIX_DOWNLOAD_PLAIN_TEXT_FAILURE'

export const MORFIX_UPLOAD_PLAIN_TEXT_REQUEST = 'MORFIX_UPLOAD_PLAIN_TEXT_REQUEST'
export const MORFIX_UPLOAD_PLAIN_TEXT_SUCCESS = 'MORFIX_UPLOAD_PLAIN_TEXT_SUCCESS'
export const MORFIX_UPLOAD_PLAIN_TEXT_FAILURE = 'MORFIX_UPLOAD_PLAIN_TEXT_FAILURE'

export const MORFIX_LOAD_PLAIN_TEXT_REQUEST = 'MORFIX_LOAD_PLAIN_TEXT_REQUEST'
export const MORFIX_LOAD_PLAIN_TEXT_SUCCESS = 'MORFIX_LOAD_PLAIN_TEXT_SUCCESS'
export const MORFIX_LOAD_PLAIN_TEXT_FAILURE = 'MORFIX_LOAD_PLAIN_TEXT_FAILURE'

export const MORFIX_CREATE_CIPHER_TEXT_REQUEST = 'MORFIX_CREATE_CIPHER_TEXT_REQUEST'
export const MORFIX_CREATE_CIPHER_TEXT_SUCCESS = 'MORFIX_CREATE_CIPHER_TEXT_SUCCESS'
export const MORFIX_CREATE_CIPHER_TEXT_FAILURE = 'MORFIX_CREATE_CIPHER_TEXT_FAILURE'

export const MORFIX_READ_CIPHER_TEXT_REQUEST = 'MORFIX_READ_CIPHER_TEXT_REQUEST'
export const MORFIX_READ_CIPHER_TEXT_SUCCESS = 'MORFIX_READ_CIPHER_TEXT_SUCCESS'
export const MORFIX_READ_CIPHER_TEXT_FAILURE = 'MORFIX_READ_CIPHER_TEXT_FAILURE'

export const MORFIX_UPDATE_CIPHER_TEXT_REQUEST = 'MORFIX_UPDATE_CIPHER_TEXT_REQUEST'
export const MORFIX_UPDATE_CIPHER_TEXT_SUCCESS = 'MORFIX_UPDATE_CIPHER_TEXT_SUCCESS'
export const MORFIX_UPDATE_CIPHER_TEXT_FAILURE = 'MORFIX_UPDATE_CIPHER_TEXT_FAILURE'

export const MORFIX_DELETE_CIPHER_TEXT_REQUEST = 'MORFIX_DELETE_CIPHER_TEXT_REQUEST'
export const MORFIX_DELETE_CIPHER_TEXT_SUCCESS = 'MORFIX_DELETE_CIPHER_TEXT_SUCCESS'
export const MORFIX_DELETE_CIPHER_TEXT_FAILURE = 'MORFIX_DELETE_CIPHER_TEXT_FAILURE'

export const MORFIX_DOWNLOAD_CIPHER_TEXT_REQUEST = 'MORFIX_DOWNLOAD_CIPHER_TEXT_REQUEST'
export const MORFIX_DOWNLOAD_CIPHER_TEXT_SUCCESS = 'MORFIX_DOWNLOAD_CIPHER_TEXT_SUCCESS'
export const MORFIX_DOWNLOAD_CIPHER_TEXT_FAILURE = 'MORFIX_DOWNLOAD_CIPHER_TEXT_FAILURE'

export const MORFIX_UPLOAD_CIPHER_TEXT_REQUEST = 'MORFIX_UPLOAD_CIPHER_TEXT_REQUEST'
export const MORFIX_UPLOAD_CIPHER_TEXT_SUCCESS = 'MORFIX_UPLOAD_CIPHER_TEXT_SUCCESS'
export const MORFIX_UPLOAD_CIPHER_TEXT_FAILURE = 'MORFIX_UPLOAD_CIPHER_TEXT_FAILURE'

export const MORFIX_LOAD_CIPHER_TEXT_REQUEST = 'MORFIX_LOAD_CIPHER_TEXT_REQUEST'
export const MORFIX_LOAD_CIPHER_TEXT_SUCCESS = 'MORFIX_LOAD_CIPHER_TEXT_SUCCESS'
export const MORFIX_LOAD_CIPHER_TEXT_FAILURE = 'MORFIX_LOAD_CIPHER_TEXT_FAILURE'

export const MORFIX_ENGINE_CREATE_ACTION_REQUEST = 'MORFIX_ENGINE_CREATE_ACTION_REQUEST'
export const MORFIX_ENGINE_CREATE_ACTION_SUCCESS = 'MORFIX_ENGINE_CREATE_ACTION_SUCCESS'
export const MORFIX_ENGINE_CREATE_ACTION_FAILURE = 'MORFIX_ENGINE_CREATE_ACTION_FAILURE'

export const MORFIX_ENGINE_UPDATE_ACTION_REQUEST = 'MORFIX_ENGINE_UPDATE_ACTION_REQUEST'
export const MORFIX_ENGINE_UPDATE_ACTION_SUCCESS = 'MORFIX_ENGINE_UPDATE_ACTION_SUCCESS'
export const MORFIX_ENGINE_UPDATE_ACTION_FAILURE = 'MORFIX_ENGINE_UPDATE_ACTION_FAILURE'

export const MORFIX_ENGINE_DELETE_ACTION_REQUEST = 'MORFIX_ENGINE_DELETE_ACTION_REQUEST'
export const MORFIX_ENGINE_DELETE_ACTION_SUCCESS = 'MORFIX_ENGINE_DELETE_ACTION_SUCCESS'
export const MORFIX_ENGINE_DELETE_ACTION_FAILURE = 'MORFIX_ENGINE_DELETE_ACTION_FAILURE'

export const MORFIX_ENGINE_EXECUTE_ALL_ACTIONS_REQUEST = 'MORFIX_ENGINE_EXECUTE_ALL_ACTIONS_REQUEST'
export const MORFIX_ENGINE_EXECUTE_ALL_ACTIONS_SUCCESS = 'MORFIX_ENGINE_EXECUTE_ALL_ACTIONS_SUCCESS'
export const MORFIX_ENGINE_EXECUTE_ALL_ACTIONS_FAILURE = 'MORFIX_ENGINE_EXECUTE_ALL_ACTIONS_FAILURE'

export const MORFIX_EVALUATE_NEGATE_CIPHER_REQUEST = 'MORFIX_EVALUATE_NEGATE_CIPHER_REQUEST'
export const MORFIX_EVALUATE_NEGATE_CIPHER_SUCCESS = 'MORFIX_EVALUATE_NEGATE_CIPHER_SUCCESS'
export const MORFIX_EVALUATE_NEGATE_CIPHER_FAILURE = 'MORFIX_EVALUATE_NEGATE_CIPHER_FAILURE'

export const MORFIX_EVALUATE_ADD_CIPHER_TO_CIPHER_REQUEST = 'MORFIX_EVALUATE_ADD_CIPHER_TO_CIPHER_REQUEST'
export const MORFIX_EVALUATE_ADD_CIPHER_TO_CIPHER_SUCCESS = 'MORFIX_EVALUATE_ADD_CIPHER_TO_CIPHER_SUCCESS'
export const MORFIX_EVALUATE_ADD_CIPHER_TO_CIPHER_FAILURE = 'MORFIX_EVALUATE_ADD_CIPHER_TO_CIPHER_FAILURE'

export const MORFIX_EVALUATE_ADD_PLAIN_TO_CIPHER_REQUEST = 'MORFIX_EVALUATE_ADD_PLAIN_TO_CIPHER_REQUEST'
export const MORFIX_EVALUATE_ADD_PLAIN_TO_CIPHER_SUCCESS = 'MORFIX_EVALUATE_ADD_PLAIN_TO_CIPHER_SUCCESS'
export const MORFIX_EVALUATE_ADD_PLAIN_TO_CIPHER_FAILURE = 'MORFIX_EVALUATE_ADD_PLAIN_TO_CIPHER_FAILURE'

export const MORFIX_EVALUATE_SUB_CIPHER_FROM_CIPHER_REQUEST = 'MORFIX_EVALUATE_SUB_CIPHER_FROM_CIPHER_REQUEST'
export const MORFIX_EVALUATE_SUB_CIPHER_FROM_CIPHER_SUCCESS = 'MORFIX_EVALUATE_SUB_CIPHER_FROM_CIPHER_SUCCESS'
export const MORFIX_EVALUATE_SUB_CIPHER_FROM_CIPHER_FAILURE = 'MORFIX_EVALUATE_SUB_CIPHER_FROM_CIPHER_FAILURE'

export const MORFIX_EVALUATE_SUB_PLAIN_FROM_CIPHER_REQUEST = 'MORFIX_EVALUATE_SUB_PLAIN_FROM_CIPHER_REQUEST'
export const MORFIX_EVALUATE_SUB_PLAIN_FROM_CIPHER_SUCCESS = 'MORFIX_EVALUATE_SUB_PLAIN_FROM_CIPHER_SUCCESS'
export const MORFIX_EVALUATE_SUB_PLAIN_FROM_CIPHER_FAILURE = 'MORFIX_EVALUATE_SUB_PLAIN_FROM_CIPHER_FAILURE'

export const MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_CIPHER_REQUEST = 'MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_CIPHER_REQUEST'
export const MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_CIPHER_SUCCESS = 'MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_CIPHER_SUCCESS'
export const MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_CIPHER_FAILURE = 'MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_CIPHER_FAILURE'

export const MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_PLAIN_REQUEST = 'MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_PLAIN_REQUEST'
export const MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_PLAIN_SUCCESS = 'MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_PLAIN_SUCCESS'
export const MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_PLAIN_FAILURE = 'MORFIX_EVALUATE_MULTIPLY_CIPHER_BY_PLAIN_FAILURE'

export const MORFIX_EVALUATE_SQUARE_CIPHER_REQUEST = 'MORFIX_EVALUATE_SQUARE_CIPHER_REQUEST'
export const MORFIX_EVALUATE_SQUARE_CIPHER_SUCCESS = 'MORFIX_EVALUATE_SQUARE_CIPHER_SUCCESS'
export const MORFIX_EVALUATE_SQUARE_CIPHER_FAILURE = 'MORFIX_EVALUATE_SQUARE_CIPHER_FAILURE'

export const MORFIX_EVALUATE_RELINEARIZE_CIPHER_REQUEST = 'MORFIX_EVALUATE_RELINEARIZE_CIPHER_REQUEST'
export const MORFIX_EVALUATE_RELINEARIZE_CIPHER_SUCCESS = 'MORFIX_EVALUATE_RELINEARIZE_CIPHER_SUCCESS'
export const MORFIX_EVALUATE_RELINEARIZE_CIPHER_FAILURE = 'MORFIX_EVALUATE_RELINEARIZE_CIPHER_FAILURE'

export const MORFIX_EVALUATE_EXPONENTIATE_CIPHER_REQUEST = 'MORFIX_EVALUATE_EXPONENTIATE_CIPHER_REQUEST'
export const MORFIX_EVALUATE_EXPONENTIATE_CIPHER_SUCCESS = 'MORFIX_EVALUATE_EXPONENTIATE_CIPHER_SUCCESS'
export const MORFIX_EVALUATE_EXPONENTIATE_CIPHER_FAILURE = 'MORFIX_EVALUATE_EXPONENTIATE_CIPHER_FAILURE'

export const MORFIX_EVALUATE_CIPHER_MODULUS_SWITCH_TO_NEXT_REQUEST =
  'MORFIX_EVALUATE_CIPHER_MODULUS_SWITCH_TO_NEXT_REQUEST'
export const MORFIX_EVALUATE_CIPHER_MODULUS_SWITCH_TO_NEXT_SUCCESS =
  'MORFIX_EVALUATE_CIPHER_MODULUS_SWITCH_TO_NEXT_SUCCESS'
export const MORFIX_EVALUATE_CIPHER_MODULUS_SWITCH_TO_NEXT_FAILURE =
  'MORFIX_EVALUATE_CIPHER_MODULUS_SWITCH_TO_NEXT_FAILURE'

export const MORFIX_EVALUATE_PLAIN_MODULUS_SWITCH_TO_NEXT_REQUEST =
  'MORFIX_EVALUATE_PLAIN_MODULUS_SWITCH_TO_NEXT_REQUEST'
export const MORFIX_EVALUATE_PLAIN_MODULUS_SWITCH_TO_NEXT_SUCCESS =
  'MORFIX_EVALUATE_PLAIN_MODULUS_SWITCH_TO_NEXT_SUCCESS'
export const MORFIX_EVALUATE_PLAIN_MODULUS_SWITCH_TO_NEXT_FAILURE =
  'MORFIX_EVALUATE_PLAIN_MODULUS_SWITCH_TO_NEXT_FAILURE'

export const MORFIX_EVALUATE_CIPHER_RESCALE_TO_NEXT_REQUEST = 'MORFIX_EVALUATE_CIPHER_RESCALE_TO_NEXT_REQUEST'
export const MORFIX_EVALUATE_CIPHER_RESCALE_TO_NEXT_SUCCESS = 'MORFIX_EVALUATE_CIPHER_RESCALE_TO_NEXT_SUCCESS'
export const MORFIX_EVALUATE_CIPHER_RESCALE_TO_NEXT_FAILURE = 'MORFIX_EVALUATE_CIPHER_RESCALE_TO_NEXT_FAILURE'

export const MORFIX_EVALUATE_PLAIN_TRANSFORM_TO_NTT_REQUEST = 'MORFIX_EVALUATE_PLAIN_TRANSFORM_TO_NTT_REQUEST'
export const MORFIX_EVALUATE_PLAIN_TRANSFORM_TO_NTT_SUCCESS = 'MORFIX_EVALUATE_PLAIN_TRANSFORM_TO_NTT_SUCCESS'
export const MORFIX_EVALUATE_PLAIN_TRANSFORM_TO_NTT_FAILURE = 'MORFIX_EVALUATE_PLAIN_TRANSFORM_TO_NTT_FAILURE'

export const MORFIX_EVALUATE_CIPHER_TRANSFORM_TO_NTT_REQUEST = 'MORFIX_EVALUATE_CIPHER_TRANSFORM_TO_NTT_REQUEST'
export const MORFIX_EVALUATE_CIPHER_TRANSFORM_TO_NTT_SUCCESS = 'MORFIX_EVALUATE_CIPHER_TRANSFORM_TO_NTT_SUCCESS'
export const MORFIX_EVALUATE_CIPHER_TRANSFORM_TO_NTT_FAILURE = 'MORFIX_EVALUATE_CIPHER_TRANSFORM_TO_NTT_FAILURE'

export const MORFIX_EVALUATE_CIPHER_TRANSFORM_FROM_NTT_REQUEST = 'MORFIX_EVALUATE_CIPHER_TRANSFORM_FROM_NTT_REQUEST'
export const MORFIX_EVALUATE_CIPHER_TRANSFORM_FROM_NTT_SUCCESS = 'MORFIX_EVALUATE_CIPHER_TRANSFORM_FROM_NTT_SUCCESS'
export const MORFIX_EVALUATE_CIPHER_TRANSFORM_FROM_NTT_FAILURE = 'MORFIX_EVALUATE_CIPHER_TRANSFORM_FROM_NTT_FAILURE'

export const MORFIX_EVALUATE_ROTATE_ROWS_REQUEST = 'MORFIX_EVALUATE_ROTATE_ROWS_REQUEST'
export const MORFIX_EVALUATE_ROTATE_ROWS_SUCCESS = 'MORFIX_EVALUATE_ROTATE_ROWS_SUCCESS'
export const MORFIX_EVALUATE_ROTATE_ROWS_FAILURE = 'MORFIX_EVALUATE_ROTATE_ROWS_FAILURE'

export const MORFIX_EVALUATE_ROTATE_COLUMNS_REQUEST = 'MORFIX_EVALUATE_ROTATE_COLUMNS_REQUEST'
export const MORFIX_EVALUATE_ROTATE_COLUMNS_SUCCESS = 'MORFIX_EVALUATE_ROTATE_COLUMNS_SUCCESS'
export const MORFIX_EVALUATE_ROTATE_COLUMNS_FAILURE = 'MORFIX_EVALUATE_ROTATE_COLUMNS_FAILURE'

export const MORFIX_EVALUATE_ROTATE_VECTOR_REQUEST = 'MORFIX_EVALUATE_ROTATE_VECTOR_REQUEST'
export const MORFIX_EVALUATE_ROTATE_VECTOR_SUCCESS = 'MORFIX_EVALUATE_ROTATE_VECTOR_SUCCESS'
export const MORFIX_EVALUATE_ROTATE_VECTOR_FAILURE = 'MORFIX_EVALUATE_ROTATE_VECTOR_FAILURE'

export const MORFIX_EVALUATE_COMPLEX_CONJUGATE_REQUEST = 'MORFIX_EVALUATE_COMPLEX_CONJUGATE_REQUEST'
export const MORFIX_EVALUATE_COMPLEX_CONJUGATE_SUCCESS = 'MORFIX_EVALUATE_COMPLEX_CONJUGATE_SUCCESS'
export const MORFIX_EVALUATE_COMPLEX_CONJUGATE_FAILURE = 'MORFIX_EVALUATE_COMPLEX_CONJUGATE_FAILURE'

export const MORFIX_EVALUATE_SUM_ELEMENTS_REQUEST = 'MORFIX_EVALUATE_SUM_ELEMENTS_REQUEST'
export const MORFIX_EVALUATE_SUM_ELEMENTS_SUCCESS = 'MORFIX_EVALUATE_SUM_ELEMENTS_SUCCESS'
export const MORFIX_EVALUATE_SUM_ELEMENTS_FAILURE = 'MORFIX_EVALUATE_SUM_ELEMENTS_FAILURE'

export const MORFIX_EVALUATE_DOT_PRODUCT_REQUEST = 'MORFIX_EVALUATE_DOT_PRODUCT_REQUEST'
export const MORFIX_EVALUATE_DOT_PRODUCT_SUCCESS = 'MORFIX_EVALUATE_DOT_PRODUCT_SUCCESS'
export const MORFIX_EVALUATE_DOT_PRODUCT_FAILURE = 'MORFIX_EVALUATE_DOT_PRODUCT_FAILURE'

export const MORFIX_EVALUATE_DOT_PRODUCT_PLAIN_REQUEST = 'MORFIX_EVALUATE_DOT_PRODUCT_PLAIN_REQUEST'
export const MORFIX_EVALUATE_DOT_PRODUCT_PLAIN_SUCCESS = 'MORFIX_EVALUATE_DOT_PRODUCT_PLAIN_SUCCESS'
export const MORFIX_EVALUATE_DOT_PRODUCT_PLAIN_FAILURE = 'MORFIX_EVALUATE_DOT_PRODUCT_PLAIN_FAILURE'
